import 'rxjs/add/operator/map';
// Providers.
import { WABaseService } from './wa-base.service';
import { LoggerService } from '../logger/logger-service';
import { EnvironmentService } from './environment-service';
import * as i0 from "@angular/core";
import * as i1 from "../logger/logger-service";
import * as i2 from "./environment-service";
export class MemStorageService extends WABaseService {
    constructor(logger, env) {
        super(logger, env);
        this.logger = logger;
        this.env = env;
        this.storage = {};
    }
    put(key, data) {
        this.storage[key] = data;
    }
    get(key) {
        return this.storage[key];
    }
    keyExists(key) {
        return typeof this.storage[key] !== 'undefined';
    }
    remove(key) {
        delete this.storage[key];
    }
}
MemStorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MemStorageService_Factory() { return new MemStorageService(i0.ɵɵinject(i1.LoggerService), i0.ɵɵinject(i2.EnvironmentService)); }, token: MemStorageService, providedIn: "root" });
